import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { authClient } from "../lib/authClient";

export default function VerifyEmailChangePage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<"loading" | "success" | "error">(
    "loading",
  );
  const [message, setMessage] = useState("");

  useEffect(() => {
    const handleEmailChangeCallback = async () => {
      // Verifica se há parâmetros de erro na URL
      const error = searchParams.get("error");

      if (error) {
        setStatus("error");
        setMessage(
          "Erro ao verificar mudança de email. O link pode estar expirado ou inválido.",
        );
        return;
      }

      // Se não há erro, assume sucesso e recarrega a sessão
      try {
        // Pequeno delay para garantir que o backend atualizou
        await new Promise((resolve) => setTimeout(resolve, 500));

        // Recarrega a sessão do usuário
        const sessionResponse = await authClient.getSession();

        if (sessionResponse.data?.user) {
          setStatus("success");
          setMessage("Email atualizado com sucesso! Redirecionando...");

          // Notifica mudança na sessão e redireciona
          authClient.$store.notify("$sessionSignal");

          setTimeout(() => {
            navigate("/profile", { replace: true });
          }, 2000);
        } else {
          setStatus("error");
          setMessage(
            "Não foi possível verificar a sessão. Faça login novamente.",
          );
        }
      } catch (error) {
        console.error("Erro ao processar verificação de email:", error);
        setStatus("error");
        setMessage(
          "Erro ao processar verificação de email. Tente fazer login novamente.",
        );
      }
    };

    handleEmailChangeCallback();
  }, [searchParams, navigate]);

  return (
    <div className="page-centered">
      <div className="auth-card">
        <h1>Verificação de Email</h1>

        {status === "loading" && (
          <div className="verification-status">
            <div className="loading-spinner">⏳</div>
            <p>Verificando mudança de email...</p>
          </div>
        )}

        {status === "success" && (
          <div className="verification-status success">
            <div className="status-icon">✅</div>
            <p className="auth-success">{message}</p>
          </div>
        )}

        {status === "error" && (
          <>
            <div className="verification-status error">
              <div className="status-icon">❌</div>
              <p className="auth-error">{message}</p>
            </div>

            <div className="verify-actions">
              <button
                type="button"
                onClick={() => navigate("/profile")}
                className="primary-button"
              >
                Ir para perfil
              </button>
              <button
                type="button"
                onClick={() => navigate("/login")}
                className="link-button back-link"
              >
                Voltar para login
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
